module.exports = __webpack_public_path__ + "static/media/img-slide-3.95858a08.png";